import { Component, OnInit } from '@angular/core';
import { SeoService } from '@app/core/seo/seo.service';
import { ensureLottiePlayer } from '@app/core/lottie/lottie-loader';
import { ConfigService } from 'esz-saas-lcp-ng-crud-ui';

@Component({
    standalone: false,
    selector: 'app-ws-services',
    templateUrl: './ws-services.component.html',
    styleUrls: ['./ws-services.component.scss']
})
export class WsServicesComponent implements OnInit {

    /** `id` is the anchor on this page (/services#commerce) that the home page cards and module pills link to. */
    services = [
        {
            icon: 'pi pi-cloud',
            id: 'hosted',
            title: 'BMS hosted (SaaS)',
            description: 'The 16-module platform, run for you: each customer gets isolated data, single sign-on, fine-grained access control and its own web apps, hosted in India or the UK.',
            features: ['Per-tenant data isolation in the cloud', 'Single sign-on & fine-grained screen permissions', 'Field-level audit trail on every record', 'REST, Integration Platform webhooks and MCP APIs']
        },
        {
            icon: 'pi pi-shopping-cart',
            id: 'commerce',
            title: 'Commerce & POS',
            description: 'From catalog to cash: Items, Ecom, POS, KDS, Signage and Payments cover the online storefront, the retail or restaurant counter and the order workflow behind both.',
            features: ['Multi-pack barcodes, unit pricing & variants', 'Offline-capable POS, self-order kiosks & table QR', 'Course firing to KDS & digital signage', 'Card terminals, dynamic QR, UPI & GST/VAT']
        },
        {
            icon: 'pi pi-calendar',
            id: 'bookings',
            title: 'Bookings & operations',
            description: 'Reservations and floor operations across 11 verticals for hospitality, healthcare, fitness, rentals, coworking, events and residential communities.',
            features: ['Rooms, tables, appointments, rentals & desks', 'Rate plans, waitlists with auto-promotion & folios', 'Visitor management & QR visitor passes', 'BPMS-driven housekeeping & concierge boards']
        },
        {
            icon: 'pi pi-users',
            id: 'customers',
            title: 'Customers & growth',
            description: 'Know your customers and keep them: CRM, loyalty, stored-value wallets, referral campaigns, omni-channel messaging and the portals and websites they use.',
            features: ['CRM leads, deals, segments & follow-ups', 'Points, tiers, gift cards & customer wallets', 'Promo codes & member referral campaigns', 'Email, SMS, instant messaging, push & in-app']
        },
        {
            icon: 'pi pi-sitemap',
            id: 'back-office',
            title: 'BPMS, back office & automation',
            description: 'A full Business Process Management System paired with the document hub, dynamic forms, HR and double-entry accounting your operations team lives in.',
            features: ['Visual BPMN 2.0, CMMN 1.1 & DMN 1.3 studios', 'Case Cockpit, SLA timers & Unified Work Inbox', 'Cloud document hub & dynamic task forms', 'HRIS, payroll & double-entry ledger with XML/CSV sync']
        },
        {
            icon: 'pi pi-code',
            id: 'custom',
            title: 'Custom development & consulting',
            description: 'When a module is not enough: bespoke applications, Integration Platform workflows and cloud engineering, delivered by the team that writes BMS.',
            features: ['Custom web and mobile applications', 'Integration Platform workflows & data migration', 'Managed cloud architecture and DevOps', 'Implementation, process modelling and training']
        }
    ];

    processSteps = [
        {
            title: 'Discovery',
            icon: 'pi pi-search',
            description: 'We map your outlets, roles and flows onto the modules and agree what is standard and what is custom.'
        },
        {
            title: 'Configure',
            icon: 'pi pi-cog',
            description: 'Your tenant is provisioned: sign-in, fine-grained permissions, brand, modules, business presets, workflows and payment settings.'
        },
        {
            title: 'Integrate & migrate',
            icon: 'pi pi-sync',
            description: 'Catalog, customers and accounts come across; external accounting, payroll, payment gateways and websites are connected.'
        },
        {
            title: 'Go live & support',
            icon: 'pi pi-send',
            description: 'Training, cut-over and ongoing support and releases from the same team.'
        }
    ];

    constructor(public configService: ConfigService, private seo: SeoService) { }

    ngOnInit(): void {
        this.seo.set({
            title: 'Services and BMS modules',
            description: 'BMS modules from ESZES: e-commerce, offline POS, bookings, payments, loyalty, CRM, documents, Business Process Management System (BPMN, CMMN, DMN), HR and accounting, plus custom development, Integration Platform automation and cloud hosting.',
            path: '/services'
        });
        ensureLottiePlayer();
    }
}
